import { WorkflowSettingsPopupSectionProps } from '../../WorkflowSettingsPopupContent.types';

export interface SectionUrlOverridingProps extends WorkflowSettingsPopupSectionProps {}

export enum SectionUrlOverridingOption {
    yes = 'yes',
    no = 'no',
}
